import React, { useState } from 'react'
import TextArea from 'antd/es/input/TextArea'

export const ContentTextArea = ({ value, error, onChange, name, required, disabled, placeholder, rows, filter }) => {

  const [localError, setLocalError] = useState("");

  const combinedError = localError || error;

  // wrapper for onChange
  const handleChange = (e) => {
    // normalize value
    const stringValue = e.target.value !== null && e.target.value !== undefined ? String(e.target.value) : "";

    // Check if first character is a blank space
    const startsWithSpace = stringValue.startsWith(" ");
    if (startsWithSpace) {
      const errMsg = `${name} cannot start with a space.`;
      setLocalError(errMsg);
    } else {
      setLocalError("");
    }

    const cleanedValue = e.target.value.replace(/^\s+/, ""); // remove only leading spaces
    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: cleanedValue } });
    }
  };

  return (
    <>
      {!filter && <label className="font-weight-bolder font-size-sm">
        {name}{" "}
        {required && <span style={{ color: "red" }}>*</span>}
      </label>}
      <TextArea
        placeholder={placeholder || name}
        className={combinedError ? "invalid" : ""}
        value={value}
        rows={rows}
        onChange={handleChange}
        disabled={disabled}
      />
      <small className="text-danger">
        {combinedError}
      </small>
    </>
  )
}

